export const idlePopupFetchingDataController = {
  initial: 'controllerIdle',
  states: {
    controllerIdle: {
      on: {
        SESSION_STATE_LOGGED_IN: [
          {
            target: 'fetchBonusPermissionAfterDelay',
            cond: 'isIdlePopupEnabledAndBonusPermissionRequired',
          },
          {
            target: 'fetchRecommendedGamesAfterDelay',
            cond: 'isIdlePopupEnabledAndBonusPermissionNotRequired',
          },
        ],
      },
    },
    fetchBonusPermissionAfterDelay: {
      initial: 'waitingForFetchingBonusPermission',
      states: {
        waitingForFetchingBonusPermission: {
          after: {
            5000: {
              target:
                '#root.main.idlePopupFetchingDataController.fetchBonusPermission',
            },
          },
        },
      },
    },
    fetchRecommendedGamesAfterDelay: {
      initial: 'waitingForFetchingGames',
      states: {
        waitingForFetchingGames: {
          after: {
            5000: {
              target:
                '#root.main.idlePopupFetchingDataController.fetchRecommendedGames',
            },
          },
        },
      },
    },
    fetchBonusPermission: {
      invoke: {
        src: 'fetchBonusPermission',
        onDone: [
          {
            actions: ['saveBonusPermissionState'],
            target: 'fetchRecommendedGames',
          },
        ],
      },
    },
    fetchRecommendedGames: {
      invoke: {
        src: 'fetchRecommendedGamesByAccountID',
        onDone: [
          {
            actions: ['saveRecommendedGames'],
            target: 'controllerIdle',
          },
        ],
      },
    },
  },
};
